export const isTouchDevice = () => window.matchMedia('(pointer: coarse) and (hover: none)').matches;

export const isMobile = () => window.innerWidth < 1024;

export const getComponent = (structure, id, key = false) => {
  const found = structure.find(component => component.frontId === id);
  if (key) return found[key] ? found[key] : '';
  return found;
};

export const radTodeg = r => r * (180 / Math.PI);

export const angleBetween = (v1, v2) => Math.atan2(v2.y - v1.y, v2.x - v1.x);

export const norm = (val, max, min) => (val - min) / (max - min);

export const distanceBetween = (v1, v2) => Math.sqrt((v1.x - v2.x) * (v1.x - v2.x) + (v1.y - v2.y) * (v1.y - v2.y));
